export const defaultModalOptions = {
    zIndex: 60,
};
export function showModal(modal, options) {
    const modalEl = typeof modal === 'string' ? document.getElementById(modal) : modal;
    if (!modalEl)
        return;
    if (!modalEl.classList.contains('modal'))
        return;
    const modalOverlayEl = modalEl.closest('.modal-overlay') ?? null;
    if (!modalOverlayEl)
        return;
    const opts = { ...defaultModalOptions, ...options };
    modalOverlayEl.style.zIndex = opts.zIndex.toString();
    modalOverlayEl.classList.remove('hidden');
    document.body.classList.add('no-scroll');
    setTimeout(() => {
        modalOverlayEl.classList.add('active');
    }, 50);
}
export function hideModal(modal) {
    const modalEl = typeof modal === 'string' ? document.getElementById(modal) : modal;
    if (!modalEl)
        return;
    if (!modalEl.classList.contains('modal'))
        return;
    const modalOverlayEl = modalEl.closest('.modal-overlay') ?? null;
    if (!modalOverlayEl)
        return;
    modalOverlayEl.classList.remove('active');
    setTimeout(() => {
        modalOverlayEl.classList.add('hidden');
        document.body.classList.remove('no-scroll');
    }, 300);
}
